<template>
  <div class="exefoot-box">
    <div class="iconbnt-box">
      <router-link class="iconbnt-item" :to="{name:'comment', query: paramInfo}">
        <div>
          <img src="@/assets/icon/icon-pinglun.png" />
        </div>
        <div>评论</div>
      </router-link>

      <router-link class="iconbnt-item" :to="{name:'comment', query: {...paramInfo,operate:2}}">
        <div>
          <img src="@/assets/icon/icon-zhuanjiao.png" />
        </div>
        <div>转交</div>
      </router-link>
      <router-link class="iconbnt-item" :to="{name:'addApprover', query: {...paramInfo}}">
        <div>
          <img src="@/assets/icon/icon-jiashenpiren.png" />
        </div>
        <div>加审批人</div>
      </router-link>
    </div>
    <div class="exefoot-bntbox">
      <router-link class="refuse-bnt" :to="{name:'comment',  query: {...paramInfo,operate:0}}">拒绝</router-link>
      <router-link class="agree-bnt" :to="{name:'comment', query:  {...paramInfo,operate:1}}">同意</router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    paramInfo: {}
  }
};
</script>
<style lang="less" scoped>
.exefoot-box {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  .iconbnt-box {
    flex: 1;
    display: flex;
    justify-content: space-around;
    .iconbnt-item {
      display: block;
      font-size: 0.293333rem;
      color: #666666;
      text-align: center;
      img {
        width: 0.64rem;
        height: 0.64rem;
      }
    }
  }
  .exefoot-bntbox {
    display: flex;
    .refuse-bnt {
      background-image: linear-gradient(123deg, #ffd10a 0%, #ff9e07 96%);
      margin-right: 0.266667rem;
    }
    .agree-bnt {
      background-image: linear-gradient(-56deg, #ff571d 4%, #ff8f2b 100%);
    }
    a {
      display: block;
      height: 0.96rem;
      width: 2.24rem;
      line-height: 0.96rem;
      border-radius: 0.533333rem;
      text-align: center;
      font-size: 0.426667rem;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalFoot/approvalExeFoot.vue